<template>
    <div>
        <main id="main">
            <!-- ======= Featured Services Section Section ======= -->
            <section id="featured-services">
                <div class="container">
                    <div class="row">
                        <div class="box" style="height: 5em">
                        </div>
                    </div>
                </div>
            </section><!-- End Featured Services Section -->

            <!-- ======= About Us Section ======= -->
            <section id="about">
                <div class="container" data-aos="fade-up">
                    <header class="section-header">
                        <h3>Ses Fonctionnalités</h3>
                        <p>
                            {{ fonctionnality.intro }}
                        </p>
                    </header>
                    <div class="row about-cols">
                        <template v-for="item in fonctionnality.foncts">
                            <div class="col-md-4" data-aos="fade-up" :data-aos-delay="item.delay">
                                <div class="about-col">
                                    <div class="img">
                                        <img :src="item.image" alt=""
                                             class="img-fluid">
                                        <!--<div class="icon"><i class="ion-ios-speedometer-outline"></i></div>-->
                                    </div>
                                    <h2 class="title"><a href="#">{{ item.title }}</a></h2>
                                    <p>
                                        {{ item.detail }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </section><!-- End About Us Section -->
        </main><!-- End #main -->

        <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>
        <!-- Uncomment below i you want to use a preloader -->
        <!-- <div id="preloader"></div> -->
    </div>
</template>

<script>
    import {mapState,mapActions} from 'vuex'

    export default {
        name: "index",
        computed:{
            ...mapState({
                fonctionnality: (state) => state.fonct.fonctionnality
            })
        },
        mounted() {
            this.fonctsAllAction()
        },
        methods:{
            ...mapActions('fonct',['fonctsAllAction'])
        }
    }
</script>

<style lang="scss" scoped>
    .img-fluid {
        width: 13em;
        height: 13em;
        margin: 0px 73px;
        @media (max-width: 455px) {
            margin: 0px 108px;
        }

    }
</style>